/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocationRouteImport } from './routes/_location'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as MapRouteImport } from './routes/map'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as MapIndexRouteImport } from './routes/map/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ScannerIndexRouteImport } from './routes/scanner/index'
import { Route as PublicActivateAccountTokenRouteImport } from './routes/_public/activate-account.$token'
import { Route as PublicResetPasswordTokenRouteImport } from './routes/_public/reset-password.$token'
import { Route as PublicVerifyEmailTokenRouteImport } from './routes/_public/verify-email.$token'
import { Route as InventoryDeviceTypeDeviceIdRouteImport } from './routes/inventory/$deviceType/$deviceId'
import { Route as ProfileBillingIndexRouteImport } from './routes/profile/billing/index'
import { Route as ProfileGroupsIndexRouteImport } from './routes/profile/groups/index'
import { Route as ProfileGroupsIdRouteImport } from './routes/profile/groups/$id'
import { Route as ProfileLocationsIndexRouteImport } from './routes/profile/locations/index'
import { Route as ProfileLocationsIdRouteImport } from './routes/profile/locations/$id'
import { Route as ProfileOrgsIndexRouteImport } from './routes/profile/orgs/index'
import { Route as ProfileOrgsIdRouteImport } from './routes/profile/orgs/$id'
import { Route as ProfileSettingsIndexRouteImport } from './routes/profile/settings/index'
import { Route as ProfileUsersIndexRouteImport } from './routes/profile/users/index'
import { Route as ProfileUsersIdRouteImport } from './routes/profile/users/$id'
import { Route as LocationProfileLogIndexRouteImport } from './routes/_location/profile/log/index'
import { Route as InventoryDeviceTypeDeviceIdIndexRouteImport } from './routes/inventory/$deviceType/$deviceId/index'
import { Route as InventoryDeviceTypeDeviceIdDetailsRouteImport } from './routes/inventory/$deviceType/$deviceId/details'
import { Route as InventoryDeviceTypeDeviceIdEditRouteImport } from './routes/inventory/$deviceType/$deviceId/edit'
import { Route as InventoryDeviceTypeDeviceIdReplaceRouteImport } from './routes/inventory/$deviceType/$deviceId/replace'
import { Route as ProfileLocationsLocationIdAreasIdRouteImport } from './routes/profile/locations/$locationId/areas/$id'
import { Route as ProfileOrgsOrgIdAlertsIndexRouteImport } from './routes/profile/orgs/$orgId/alerts/index'
import { Route as ProfileOrgsOrgIdRolesIdRouteImport } from './routes/profile/orgs/$orgId/roles/$id'

const LocationRoute = LocationRouteImport.update({
  id: '/_location',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/_home/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InventoryRoute,
} as any)
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MapRoute,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScannerIndexRoute = ScannerIndexRouteImport.update({
  id: '/scanner/',
  path: '/scanner/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicActivateAccountTokenRoute =
  PublicActivateAccountTokenRouteImport.update({
    id: '/activate-account/$token',
    path: '/activate-account/$token',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicResetPasswordTokenRoute =
  PublicResetPasswordTokenRouteImport.update({
    id: '/reset-password/$token',
    path: '/reset-password/$token',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicVerifyEmailTokenRoute = PublicVerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => PublicRoute,
} as any)
const InventoryDeviceTypeDeviceIdRoute =
  InventoryDeviceTypeDeviceIdRouteImport.update({
    id: '/$deviceType/$deviceId',
    path: '/$deviceType/$deviceId',
    getParentRoute: () => InventoryRoute,
  } as any)
const ProfileBillingIndexRoute = ProfileBillingIndexRouteImport.update({
  id: '/profile/billing/',
  path: '/profile/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileGroupsIndexRoute = ProfileGroupsIndexRouteImport.update({
  id: '/profile/groups/',
  path: '/profile/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileGroupsIdRoute = ProfileGroupsIdRouteImport.update({
  id: '/profile/groups/$id',
  path: '/profile/groups/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileLocationsIndexRoute = ProfileLocationsIndexRouteImport.update({
  id: '/profile/locations/',
  path: '/profile/locations/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileLocationsIdRoute = ProfileLocationsIdRouteImport.update({
  id: '/profile/locations/$id',
  path: '/profile/locations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileOrgsIndexRoute = ProfileOrgsIndexRouteImport.update({
  id: '/profile/orgs/',
  path: '/profile/orgs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileOrgsIdRoute = ProfileOrgsIdRouteImport.update({
  id: '/profile/orgs/$id',
  path: '/profile/orgs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSettingsIndexRoute = ProfileSettingsIndexRouteImport.update({
  id: '/profile/settings/',
  path: '/profile/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileUsersIndexRoute = ProfileUsersIndexRouteImport.update({
  id: '/profile/users/',
  path: '/profile/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileUsersIdRoute = ProfileUsersIdRouteImport.update({
  id: '/profile/users/$id',
  path: '/profile/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationProfileLogIndexRoute = LocationProfileLogIndexRouteImport.update({
  id: '/profile/log/',
  path: '/profile/log/',
  getParentRoute: () => LocationRoute,
} as any)
const InventoryDeviceTypeDeviceIdIndexRoute =
  InventoryDeviceTypeDeviceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InventoryDeviceTypeDeviceIdRoute,
  } as any)
const InventoryDeviceTypeDeviceIdDetailsRoute =
  InventoryDeviceTypeDeviceIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => InventoryDeviceTypeDeviceIdRoute,
  } as any)
const InventoryDeviceTypeDeviceIdEditRoute =
  InventoryDeviceTypeDeviceIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => InventoryDeviceTypeDeviceIdRoute,
  } as any)
const InventoryDeviceTypeDeviceIdReplaceRoute =
  InventoryDeviceTypeDeviceIdReplaceRouteImport.update({
    id: '/replace',
    path: '/replace',
    getParentRoute: () => InventoryDeviceTypeDeviceIdRoute,
  } as any)
const ProfileLocationsLocationIdAreasIdRoute =
  ProfileLocationsLocationIdAreasIdRouteImport.update({
    id: '/profile/locations/$locationId/areas/$id',
    path: '/profile/locations/$locationId/areas/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileOrgsOrgIdAlertsIndexRoute =
  ProfileOrgsOrgIdAlertsIndexRouteImport.update({
    id: '/profile/orgs/$orgId/alerts/',
    path: '/profile/orgs/$orgId/alerts/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileOrgsOrgIdRolesIdRoute = ProfileOrgsOrgIdRolesIdRouteImport.update({
  id: '/profile/orgs/$orgId/roles/$id',
  path: '/profile/orgs/$orgId/roles/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof HomeIndexRoute
  '/inventory': typeof InventoryRouteWithChildren
  '/map': typeof MapRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/inventory/': typeof InventoryIndexRoute
  '/map/': typeof MapIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/scanner/': typeof ScannerIndexRoute
  '/activate-account/$token': typeof PublicActivateAccountTokenRoute
  '/reset-password/$token': typeof PublicResetPasswordTokenRoute
  '/verify-email/$token': typeof PublicVerifyEmailTokenRoute
  '/inventory/$deviceType/$deviceId': typeof InventoryDeviceTypeDeviceIdRouteWithChildren
  '/profile/groups/$id': typeof ProfileGroupsIdRoute
  '/profile/locations/$id': typeof ProfileLocationsIdRoute
  '/profile/orgs/$id': typeof ProfileOrgsIdRoute
  '/profile/users/$id': typeof ProfileUsersIdRoute
  '/profile/billing/': typeof ProfileBillingIndexRoute
  '/profile/groups/': typeof ProfileGroupsIndexRoute
  '/profile/locations/': typeof ProfileLocationsIndexRoute
  '/profile/orgs/': typeof ProfileOrgsIndexRoute
  '/profile/settings/': typeof ProfileSettingsIndexRoute
  '/profile/users/': typeof ProfileUsersIndexRoute
  '/inventory/$deviceType/$deviceId/details': typeof InventoryDeviceTypeDeviceIdDetailsRoute
  '/inventory/$deviceType/$deviceId/edit': typeof InventoryDeviceTypeDeviceIdEditRoute
  '/inventory/$deviceType/$deviceId/replace': typeof InventoryDeviceTypeDeviceIdReplaceRoute
  '/profile/log/': typeof LocationProfileLogIndexRoute
  '/inventory/$deviceType/$deviceId/': typeof InventoryDeviceTypeDeviceIdIndexRoute
  '/profile/locations/$locationId/areas/$id': typeof ProfileLocationsLocationIdAreasIdRoute
  '/profile/orgs/$orgId/roles/$id': typeof ProfileOrgsOrgIdRolesIdRoute
  '/profile/orgs/$orgId/alerts/': typeof ProfileOrgsOrgIdAlertsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof HomeIndexRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/inventory': typeof InventoryIndexRoute
  '/map': typeof MapIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/scanner': typeof ScannerIndexRoute
  '/activate-account/$token': typeof PublicActivateAccountTokenRoute
  '/reset-password/$token': typeof PublicResetPasswordTokenRoute
  '/verify-email/$token': typeof PublicVerifyEmailTokenRoute
  '/profile/groups/$id': typeof ProfileGroupsIdRoute
  '/profile/locations/$id': typeof ProfileLocationsIdRoute
  '/profile/orgs/$id': typeof ProfileOrgsIdRoute
  '/profile/users/$id': typeof ProfileUsersIdRoute
  '/profile/billing': typeof ProfileBillingIndexRoute
  '/profile/groups': typeof ProfileGroupsIndexRoute
  '/profile/locations': typeof ProfileLocationsIndexRoute
  '/profile/orgs': typeof ProfileOrgsIndexRoute
  '/profile/settings': typeof ProfileSettingsIndexRoute
  '/profile/users': typeof ProfileUsersIndexRoute
  '/inventory/$deviceType/$deviceId/details': typeof InventoryDeviceTypeDeviceIdDetailsRoute
  '/inventory/$deviceType/$deviceId/edit': typeof InventoryDeviceTypeDeviceIdEditRoute
  '/inventory/$deviceType/$deviceId/replace': typeof InventoryDeviceTypeDeviceIdReplaceRoute
  '/profile/log': typeof LocationProfileLogIndexRoute
  '/inventory/$deviceType/$deviceId': typeof InventoryDeviceTypeDeviceIdIndexRoute
  '/profile/locations/$locationId/areas/$id': typeof ProfileLocationsLocationIdAreasIdRoute
  '/profile/orgs/$orgId/roles/$id': typeof ProfileOrgsOrgIdRolesIdRoute
  '/profile/orgs/$orgId/alerts': typeof ProfileOrgsOrgIdAlertsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_location': typeof LocationRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/inventory': typeof InventoryRouteWithChildren
  '/map': typeof MapRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_home/': typeof HomeIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/map/': typeof MapIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/scanner/': typeof ScannerIndexRoute
  '/_public/activate-account/$token': typeof PublicActivateAccountTokenRoute
  '/_public/reset-password/$token': typeof PublicResetPasswordTokenRoute
  '/_public/verify-email/$token': typeof PublicVerifyEmailTokenRoute
  '/inventory/$deviceType/$deviceId': typeof InventoryDeviceTypeDeviceIdRouteWithChildren
  '/profile/groups/$id': typeof ProfileGroupsIdRoute
  '/profile/locations/$id': typeof ProfileLocationsIdRoute
  '/profile/orgs/$id': typeof ProfileOrgsIdRoute
  '/profile/users/$id': typeof ProfileUsersIdRoute
  '/profile/billing/': typeof ProfileBillingIndexRoute
  '/profile/groups/': typeof ProfileGroupsIndexRoute
  '/profile/locations/': typeof ProfileLocationsIndexRoute
  '/profile/orgs/': typeof ProfileOrgsIndexRoute
  '/profile/settings/': typeof ProfileSettingsIndexRoute
  '/profile/users/': typeof ProfileUsersIndexRoute
  '/inventory/$deviceType/$deviceId/details': typeof InventoryDeviceTypeDeviceIdDetailsRoute
  '/inventory/$deviceType/$deviceId/edit': typeof InventoryDeviceTypeDeviceIdEditRoute
  '/inventory/$deviceType/$deviceId/replace': typeof InventoryDeviceTypeDeviceIdReplaceRoute
  '/_location/profile/log/': typeof LocationProfileLogIndexRoute
  '/inventory/$deviceType/$deviceId/': typeof InventoryDeviceTypeDeviceIdIndexRoute
  '/profile/locations/$locationId/areas/$id': typeof ProfileLocationsLocationIdAreasIdRoute
  '/profile/orgs/$orgId/roles/$id': typeof ProfileOrgsOrgIdRolesIdRoute
  '/profile/orgs/$orgId/alerts/': typeof ProfileOrgsOrgIdAlertsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inventory'
    | '/map'
    | '/forgot-password'
    | '/inventory/'
    | '/map/'
    | '/profile/'
    | '/scanner/'
    | '/activate-account/$token'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/inventory/$deviceType/$deviceId'
    | '/profile/groups/$id'
    | '/profile/locations/$id'
    | '/profile/orgs/$id'
    | '/profile/users/$id'
    | '/profile/billing/'
    | '/profile/groups/'
    | '/profile/locations/'
    | '/profile/orgs/'
    | '/profile/settings/'
    | '/profile/users/'
    | '/inventory/$deviceType/$deviceId/details'
    | '/inventory/$deviceType/$deviceId/edit'
    | '/inventory/$deviceType/$deviceId/replace'
    | '/profile/log/'
    | '/inventory/$deviceType/$deviceId/'
    | '/profile/locations/$locationId/areas/$id'
    | '/profile/orgs/$orgId/roles/$id'
    | '/profile/orgs/$orgId/alerts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/inventory'
    | '/map'
    | '/profile'
    | '/scanner'
    | '/activate-account/$token'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/profile/groups/$id'
    | '/profile/locations/$id'
    | '/profile/orgs/$id'
    | '/profile/users/$id'
    | '/profile/billing'
    | '/profile/groups'
    | '/profile/locations'
    | '/profile/orgs'
    | '/profile/settings'
    | '/profile/users'
    | '/inventory/$deviceType/$deviceId/details'
    | '/inventory/$deviceType/$deviceId/edit'
    | '/inventory/$deviceType/$deviceId/replace'
    | '/profile/log'
    | '/inventory/$deviceType/$deviceId'
    | '/profile/locations/$locationId/areas/$id'
    | '/profile/orgs/$orgId/roles/$id'
    | '/profile/orgs/$orgId/alerts'
  id:
    | '__root__'
    | '/_location'
    | '/_public'
    | '/inventory'
    | '/map'
    | '/_public/forgot-password'
    | '/_home/'
    | '/inventory/'
    | '/map/'
    | '/profile/'
    | '/scanner/'
    | '/_public/activate-account/$token'
    | '/_public/reset-password/$token'
    | '/_public/verify-email/$token'
    | '/inventory/$deviceType/$deviceId'
    | '/profile/groups/$id'
    | '/profile/locations/$id'
    | '/profile/orgs/$id'
    | '/profile/users/$id'
    | '/profile/billing/'
    | '/profile/groups/'
    | '/profile/locations/'
    | '/profile/orgs/'
    | '/profile/settings/'
    | '/profile/users/'
    | '/inventory/$deviceType/$deviceId/details'
    | '/inventory/$deviceType/$deviceId/edit'
    | '/inventory/$deviceType/$deviceId/replace'
    | '/_location/profile/log/'
    | '/inventory/$deviceType/$deviceId/'
    | '/profile/locations/$locationId/areas/$id'
    | '/profile/orgs/$orgId/roles/$id'
    | '/profile/orgs/$orgId/alerts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LocationRoute: typeof LocationRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  InventoryRoute: typeof InventoryRouteWithChildren
  MapRoute: typeof MapRouteWithChildren
  HomeIndexRoute: typeof HomeIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  ScannerIndexRoute: typeof ScannerIndexRoute
  ProfileGroupsIdRoute: typeof ProfileGroupsIdRoute
  ProfileLocationsIdRoute: typeof ProfileLocationsIdRoute
  ProfileOrgsIdRoute: typeof ProfileOrgsIdRoute
  ProfileUsersIdRoute: typeof ProfileUsersIdRoute
  ProfileBillingIndexRoute: typeof ProfileBillingIndexRoute
  ProfileGroupsIndexRoute: typeof ProfileGroupsIndexRoute
  ProfileLocationsIndexRoute: typeof ProfileLocationsIndexRoute
  ProfileOrgsIndexRoute: typeof ProfileOrgsIndexRoute
  ProfileSettingsIndexRoute: typeof ProfileSettingsIndexRoute
  ProfileUsersIndexRoute: typeof ProfileUsersIndexRoute
  ProfileLocationsLocationIdAreasIdRoute: typeof ProfileLocationsLocationIdAreasIdRoute
  ProfileOrgsOrgIdRolesIdRoute: typeof ProfileOrgsOrgIdRolesIdRoute
  ProfileOrgsOrgIdAlertsIndexRoute: typeof ProfileOrgsOrgIdAlertsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_location': {
      id: '/_location'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/map/': {
      id: '/map/'
      path: '/'
      fullPath: '/map/'
      preLoaderRoute: typeof MapIndexRouteImport
      parentRoute: typeof MapRoute
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scanner/': {
      id: '/scanner/'
      path: '/scanner'
      fullPath: '/scanner/'
      preLoaderRoute: typeof ScannerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/activate-account/$token': {
      id: '/_public/activate-account/$token'
      path: '/activate-account/$token'
      fullPath: '/activate-account/$token'
      preLoaderRoute: typeof PublicActivateAccountTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password/$token': {
      id: '/_public/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof PublicResetPasswordTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/verify-email/$token': {
      id: '/_public/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/verify-email/$token'
      preLoaderRoute: typeof PublicVerifyEmailTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/inventory/$deviceType/$deviceId': {
      id: '/inventory/$deviceType/$deviceId'
      path: '/$deviceType/$deviceId'
      fullPath: '/inventory/$deviceType/$deviceId'
      preLoaderRoute: typeof InventoryDeviceTypeDeviceIdRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/profile/billing/': {
      id: '/profile/billing/'
      path: '/profile/billing'
      fullPath: '/profile/billing/'
      preLoaderRoute: typeof ProfileBillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/groups/': {
      id: '/profile/groups/'
      path: '/profile/groups'
      fullPath: '/profile/groups/'
      preLoaderRoute: typeof ProfileGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/groups/$id': {
      id: '/profile/groups/$id'
      path: '/profile/groups/$id'
      fullPath: '/profile/groups/$id'
      preLoaderRoute: typeof ProfileGroupsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/locations/': {
      id: '/profile/locations/'
      path: '/profile/locations'
      fullPath: '/profile/locations/'
      preLoaderRoute: typeof ProfileLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/locations/$id': {
      id: '/profile/locations/$id'
      path: '/profile/locations/$id'
      fullPath: '/profile/locations/$id'
      preLoaderRoute: typeof ProfileLocationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/orgs/': {
      id: '/profile/orgs/'
      path: '/profile/orgs'
      fullPath: '/profile/orgs/'
      preLoaderRoute: typeof ProfileOrgsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/orgs/$id': {
      id: '/profile/orgs/$id'
      path: '/profile/orgs/$id'
      fullPath: '/profile/orgs/$id'
      preLoaderRoute: typeof ProfileOrgsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/settings/': {
      id: '/profile/settings/'
      path: '/profile/settings'
      fullPath: '/profile/settings/'
      preLoaderRoute: typeof ProfileSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/users/': {
      id: '/profile/users/'
      path: '/profile/users'
      fullPath: '/profile/users/'
      preLoaderRoute: typeof ProfileUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/users/$id': {
      id: '/profile/users/$id'
      path: '/profile/users/$id'
      fullPath: '/profile/users/$id'
      preLoaderRoute: typeof ProfileUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_location/profile/log/': {
      id: '/_location/profile/log/'
      path: '/profile/log'
      fullPath: '/profile/log/'
      preLoaderRoute: typeof LocationProfileLogIndexRouteImport
      parentRoute: typeof LocationRoute
    }
    '/inventory/$deviceType/$deviceId/': {
      id: '/inventory/$deviceType/$deviceId/'
      path: '/'
      fullPath: '/inventory/$deviceType/$deviceId/'
      preLoaderRoute: typeof InventoryDeviceTypeDeviceIdIndexRouteImport
      parentRoute: typeof InventoryDeviceTypeDeviceIdRoute
    }
    '/inventory/$deviceType/$deviceId/details': {
      id: '/inventory/$deviceType/$deviceId/details'
      path: '/details'
      fullPath: '/inventory/$deviceType/$deviceId/details'
      preLoaderRoute: typeof InventoryDeviceTypeDeviceIdDetailsRouteImport
      parentRoute: typeof InventoryDeviceTypeDeviceIdRoute
    }
    '/inventory/$deviceType/$deviceId/edit': {
      id: '/inventory/$deviceType/$deviceId/edit'
      path: '/edit'
      fullPath: '/inventory/$deviceType/$deviceId/edit'
      preLoaderRoute: typeof InventoryDeviceTypeDeviceIdEditRouteImport
      parentRoute: typeof InventoryDeviceTypeDeviceIdRoute
    }
    '/inventory/$deviceType/$deviceId/replace': {
      id: '/inventory/$deviceType/$deviceId/replace'
      path: '/replace'
      fullPath: '/inventory/$deviceType/$deviceId/replace'
      preLoaderRoute: typeof InventoryDeviceTypeDeviceIdReplaceRouteImport
      parentRoute: typeof InventoryDeviceTypeDeviceIdRoute
    }
    '/profile/locations/$locationId/areas/$id': {
      id: '/profile/locations/$locationId/areas/$id'
      path: '/profile/locations/$locationId/areas/$id'
      fullPath: '/profile/locations/$locationId/areas/$id'
      preLoaderRoute: typeof ProfileLocationsLocationIdAreasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/orgs/$orgId/alerts/': {
      id: '/profile/orgs/$orgId/alerts/'
      path: '/profile/orgs/$orgId/alerts'
      fullPath: '/profile/orgs/$orgId/alerts/'
      preLoaderRoute: typeof ProfileOrgsOrgIdAlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/orgs/$orgId/roles/$id': {
      id: '/profile/orgs/$orgId/roles/$id'
      path: '/profile/orgs/$orgId/roles/$id'
      fullPath: '/profile/orgs/$orgId/roles/$id'
      preLoaderRoute: typeof ProfileOrgsOrgIdRolesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface LocationRouteChildren {
  LocationProfileLogIndexRoute: typeof LocationProfileLogIndexRoute
}

const LocationRouteChildren: LocationRouteChildren = {
  LocationProfileLogIndexRoute: LocationProfileLogIndexRoute,
}

const LocationRouteWithChildren = LocationRoute._addFileChildren(
  LocationRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicActivateAccountTokenRoute: typeof PublicActivateAccountTokenRoute
  PublicResetPasswordTokenRoute: typeof PublicResetPasswordTokenRoute
  PublicVerifyEmailTokenRoute: typeof PublicVerifyEmailTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicActivateAccountTokenRoute: PublicActivateAccountTokenRoute,
  PublicResetPasswordTokenRoute: PublicResetPasswordTokenRoute,
  PublicVerifyEmailTokenRoute: PublicVerifyEmailTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface InventoryDeviceTypeDeviceIdRouteChildren {
  InventoryDeviceTypeDeviceIdDetailsRoute: typeof InventoryDeviceTypeDeviceIdDetailsRoute
  InventoryDeviceTypeDeviceIdEditRoute: typeof InventoryDeviceTypeDeviceIdEditRoute
  InventoryDeviceTypeDeviceIdReplaceRoute: typeof InventoryDeviceTypeDeviceIdReplaceRoute
  InventoryDeviceTypeDeviceIdIndexRoute: typeof InventoryDeviceTypeDeviceIdIndexRoute
}

const InventoryDeviceTypeDeviceIdRouteChildren: InventoryDeviceTypeDeviceIdRouteChildren =
  {
    InventoryDeviceTypeDeviceIdDetailsRoute:
      InventoryDeviceTypeDeviceIdDetailsRoute,
    InventoryDeviceTypeDeviceIdEditRoute: InventoryDeviceTypeDeviceIdEditRoute,
    InventoryDeviceTypeDeviceIdReplaceRoute:
      InventoryDeviceTypeDeviceIdReplaceRoute,
    InventoryDeviceTypeDeviceIdIndexRoute:
      InventoryDeviceTypeDeviceIdIndexRoute,
  }

const InventoryDeviceTypeDeviceIdRouteWithChildren =
  InventoryDeviceTypeDeviceIdRoute._addFileChildren(
    InventoryDeviceTypeDeviceIdRouteChildren,
  )

interface InventoryRouteChildren {
  InventoryIndexRoute: typeof InventoryIndexRoute
  InventoryDeviceTypeDeviceIdRoute: typeof InventoryDeviceTypeDeviceIdRouteWithChildren
}

const InventoryRouteChildren: InventoryRouteChildren = {
  InventoryIndexRoute: InventoryIndexRoute,
  InventoryDeviceTypeDeviceIdRoute:
    InventoryDeviceTypeDeviceIdRouteWithChildren,
}

const InventoryRouteWithChildren = InventoryRoute._addFileChildren(
  InventoryRouteChildren,
)

interface MapRouteChildren {
  MapIndexRoute: typeof MapIndexRoute
}

const MapRouteChildren: MapRouteChildren = {
  MapIndexRoute: MapIndexRoute,
}

const MapRouteWithChildren = MapRoute._addFileChildren(MapRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LocationRoute: LocationRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  InventoryRoute: InventoryRouteWithChildren,
  MapRoute: MapRouteWithChildren,
  HomeIndexRoute: HomeIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  ScannerIndexRoute: ScannerIndexRoute,
  ProfileGroupsIdRoute: ProfileGroupsIdRoute,
  ProfileLocationsIdRoute: ProfileLocationsIdRoute,
  ProfileOrgsIdRoute: ProfileOrgsIdRoute,
  ProfileUsersIdRoute: ProfileUsersIdRoute,
  ProfileBillingIndexRoute: ProfileBillingIndexRoute,
  ProfileGroupsIndexRoute: ProfileGroupsIndexRoute,
  ProfileLocationsIndexRoute: ProfileLocationsIndexRoute,
  ProfileOrgsIndexRoute: ProfileOrgsIndexRoute,
  ProfileSettingsIndexRoute: ProfileSettingsIndexRoute,
  ProfileUsersIndexRoute: ProfileUsersIndexRoute,
  ProfileLocationsLocationIdAreasIdRoute:
    ProfileLocationsLocationIdAreasIdRoute,
  ProfileOrgsOrgIdRolesIdRoute: ProfileOrgsOrgIdRolesIdRoute,
  ProfileOrgsOrgIdAlertsIndexRoute: ProfileOrgsOrgIdAlertsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
